(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-gallery"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__customerGalleryBound) return;
  window.__customerGalleryBound = true;

  document.addEventListener('click', function (e) {
    // Open
    var openBtn = e.target.closest('[data-cg-open]');
    if (openBtn) {
      var dlg = document.getElementById(openBtn.getAttribute('data-cg-open'));
      if (dlg) {
        if (typeof dlg.showModal === 'function') { dlg.showModal(); }
        else { dlg.setAttribute('open', ''); }
      }
      return;
    }

    // Close button
    var closeBtn = e.target.closest('[data-cg-close]');
    if (closeBtn) {
      var d = closeBtn.closest('dialog');
      if (d) { if (typeof d.close === 'function') { d.close(); } else { d.removeAttribute('open'); } }
      return;
    }

    // Thumbnail -> swap main image
    var thumb = e.target.closest('[data-cg-thumb]');
    if (thumb) {
      var modal = thumb.closest('.customer-gallery__modal');
      var main = modal && modal.querySelector('[data-cg-main-image]');
      if (main) {
        main.src = thumb.getAttribute('data-cg-thumb');
        main.removeAttribute('srcset');
      }
      return;
    }

    // Click on backdrop (the dialog element itself) closes it
    if (e.target.matches && e.target.matches('dialog.customer-gallery__modal')) {
      if (typeof e.target.close === 'function') { e.target.close(); }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
